import { createSelector } from 'reselect';

const selectNotification = (state) => state.notification;

const selectNotificationMessages = createSelector(
	selectNotification,
	(notification) => notification?.messages
);

const notificationSelectors = {
	selectNotification,
	selectNotificationMessages,
};

export default notificationSelectors;
